import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'

export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0'};
`
